import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Flex, Spinner } from '@chakra-ui/react';
import { FT_PI_PROMO_CODE_LANDING_PAGE, FT_CCUI_PROMO_CODE_LANDING_PAGE, FT_BB_PROMO_CODE_LANDING_PAGE } from '@whitbread-eos/api';
import { useFeatureToggle, formatDataTestId, deleteCookie } from '@whitbread-eos/utils';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { Price, Dismiss } from '../../assets/icons';
import Icon from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var isNonEmptyString = value => typeof value === 'string' && value.trim().length > 0;
export default function PromoTag(_ref) {
  var rateDiscountTags = _ref.rateDiscountTags,
    customStyleName = _ref.customStyleName,
    promoActions = _ref.promoActions;
  var router = useRouter();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isRemoving = _useState2[0],
    setIsRemoving = _useState2[1];
  var _useFeatureToggle = useFeatureToggle(),
    isPromoCodeLandingPageEnabled = _useFeatureToggle[FT_PI_PROMO_CODE_LANDING_PAGE],
    isCcuiPromoCodeLandingPageEnabled = _useFeatureToggle[FT_CCUI_PROMO_CODE_LANDING_PAGE],
    isBBPromoCodeLandingPageEnabled = _useFeatureToggle[FT_BB_PROMO_CODE_LANDING_PAGE];
  var isPromoTagEnabled = isPromoCodeLandingPageEnabled || isCcuiPromoCodeLandingPageEnabled || isBBPromoCodeLandingPageEnabled;
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    validTags = _useState4[0],
    setValidTags = _useState4[1];
  useEffect(() => {
    if (isPromoTagEnabled) {
      var _rateDiscountTags$fil;
      var filteredTags = (_rateDiscountTags$fil = rateDiscountTags === null || rateDiscountTags === void 0 ? void 0 : rateDiscountTags.filter(isNonEmptyString)) !== null && _rateDiscountTags$fil !== void 0 ? _rateDiscountTags$fil : [];
      setValidTags(filteredTags);
    } else {
      setValidTags([]);
    }
  }, [isPromoTagEnabled, rateDiscountTags]);
  if (validTags.length === 0) return null;
  var getCustomStyle = customStyleName => {
    switch (customStyleName) {
      case 'rateItem':
        return customStyles.rateItemStyles;
      case 'basketComponent':
        return customStyles.basketComponentStyles;
      case 'BookingSummaryCard':
        return customStyles.BookingSummaryCardStyles;
      default:
        return {};
    }
  };
  var mergerdStyles = _objectSpread(_objectSpread({}, basePlanRateStyles), getCustomStyle(customStyleName));
  return _jsx(Flex, _objectSpread(_objectSpread({
    "data-testid": "PromotionTagComponent"
  }, promoWrapper), {}, {
    children: validTags.map((tag, index) => _jsxs(Flex, _objectSpread(_objectSpread({}, mergerdStyles), {}, {
      children: [_jsx(Icon, _objectSpread({
        svg: _jsx(Price, {})
      }, iconStyles)), tag.trim(), promoActions && (promoActions === null || promoActions === void 0 ? void 0 : promoActions.shouldShowRemoveButton) && _jsx(Flex, _objectSpread(_objectSpread({}, iconDissMissStyles), {}, {
        "data-testid": formatDataTestId('promoDiscountTag', 'remove'),
        onClick: () => {
          deleteCookie('appliedPromoBoxCode');
          if (isRemoving) return;
          setIsRemoving(true);
          router.reload();
        },
        children: isRemoving ? _jsx(Spinner, {
          size: "xs",
          thickness: "2px"
        }) : _jsx(Icon, {
          svg: _jsx(Dismiss, {
            color: "#00798e",
            width: "0.875rem",
            height: "0.875rem"
          })
        })
      }))]
    }), index))
  }));
}
var iconDissMissStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginLeft: '0.4rem',
  cursor: 'pointer',
  transition: 'transform 0.2s ease, opacity 0.2s ease',
  _hover: {
    transform: 'scale(1.2)',
    opacity: 0.8
  }
};
var iconStyles = {
  display: 'flex',
  alignItems: 'center',
  height: '1rem',
  width: '1rem',
  marginRight: '0.1875rem'
};
var basePlanRateStyles = {
  color: 'primary',
  backgroundColor: 'tooltipInfo',
  display: 'inline-flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: '1.625rem',
  borderRadius: '0.25rem',
  padding: '0.25rem 0.5rem',
  fontSize: '0.8125rem',
  fontWeight: 'bold',
  whiteSpace: 'nowrap'
};
var promoWrapper = {
  display: 'inline-flex'
};
var customStyles = {
  rateItemStyles: {
    mx: 'sm'
  },
  basketComponentStyles: {
    ml: 'sm'
  },
  BookingSummaryCardStyles: {
    mt: 'sm'
  }
};